import React from 'react';
import PropTypes from 'prop-types';

import { USER_ROLE_ADMIN } from 'common/userRoles';

import { getHelpCardTitle } from 'common/helpCardHelpers';

import SrBox from 'client/components/SrBox';
import SrPartnerOverviewPageHeader from 'client/components/SrPartnerOverviewPageHeader';
import SrDataTablePartnerListingsSection from 'client/components/SrDataTablePartnerListingsSection';
import SrPartnerMarketListing from 'client/components/SrPartnerMarketListing';
import SrDataTableMarketingPartnerListings from 'client/components/SrDataTableMarketingPartnerListings';
import SrDataTablePartnerApartments from 'client/components/SrDataTablePartnerApartments';
import SrDataTablePartnerHouseholdMoveIns from 'client/components/SrDataTablePartnerHouseholdMoveIns';
import SrDataTablePartnerHouseholdWithdrawns from 'client/components/SrDataTablePartnerHouseholdWithdrawns';
import SrDataTablePartnerHouseholdPendingApprovals from 'client/components/SrDataTablePartnerHouseholdPendingApprovals';
import SrFlex from 'client/components/SrFlex';
import SrPartnerContactAccountManager from 'client/components/SrPartnerContactAccountManager';
import SrPartnerDashboardMarketingSection from 'client/components/SrPartnerDashboardMarketingSection/SrPartnerDashboardMarketingSection';
import SrHelpCardSection from 'client/components/SrHelpCardSection/SrHelpCardSection';
import SrDataTablePartnerTenantScreeningListingsSection from 'client/components/SrDataTablePartnerTenantScreeningListingsSection';
import SrDataTablePartnerTenantScreeningArchivedListingsSection from 'client/components/SrDataTablePartnerTenantScreeningArchivedListingsSection';

const PartnerOverviewPageTenantScreening = ({
  appUrl,
  history,
  partner,
  dispatch,
  helpCards,
  currentUser,
  propertyAttributes,
  marketingPartnerListing,
  onReloadDataTableMarketingPartnerListing,
}) => {
  return (
    <>
      <SrPartnerOverviewPageHeader partner={partner} currentUser={currentUser} />
      <SrBox margin="0 16px">
        <SrPartnerMarketListing
          partner={partner}
          propertyAttributes={propertyAttributes}
          reloadDataTableMarketingPartnerListing={onReloadDataTableMarketingPartnerListing}
          currentUser={currentUser}
        />
        <SrDataTablePartnerHouseholdPendingApprovals
          currentUser={currentUser}
          partner={partner}
          history={history}
          appUrl={appUrl}
        />
        <div
          className="GoingToMarketSection"
          style={{
            scrollMargin: '50px',
          }}
        >
          <SrDataTableMarketingPartnerListings
            dispatch={dispatch}
            partner={partner}
            reloadDataTableMarketingPartnerListing={onReloadDataTableMarketingPartnerListing}
            appUrl={appUrl}
          />
        </div>
        <SrDataTablePartnerHouseholdMoveIns
          partner={partner}
          currentUser={currentUser}
          dispatch={dispatch}
          upcoming
        />
        <SrDataTablePartnerTenantScreeningListingsSection partner={partner} dispatch={dispatch} />
        <SrDataTablePartnerTenantScreeningArchivedListingsSection partner={partner} />
        <SrDataTablePartnerApartments partner={partner} />
        <SrDataTablePartnerListingsSection
          partner={partner}
          dispatch={dispatch}
          apartmentBuildingId={null}
        />
        <SrFlex width="100%" justify="center" marginTop="120px">
          <SrPartnerContactAccountManager marketingPartnerListing={marketingPartnerListing} />
        </SrFlex>
        <SrPartnerDashboardMarketingSection currentPartner={partner} appUrl={appUrl} />
        {helpCards && helpCards.length > 0 && (
          <SrBox marginTop="120px">
            <SrHelpCardSection helpCards={helpCards} title={getHelpCardTitle({ partner })} />
          </SrBox>
        )}
        {currentUser.roles.includes(USER_ROLE_ADMIN) && (
          <SrDataTablePartnerHouseholdWithdrawns partner={partner} />
        )}
        <SrDataTablePartnerHouseholdMoveIns
          partner={partner}
          currentUser={currentUser}
          upcoming={false}
          dispatch={dispatch}
        />
      </SrBox>
    </>
  );
};

PartnerOverviewPageTenantScreening.propTypes = {
  appUrl: PropTypes.string,
  history: PropTypes.object,
  partner: PropTypes.object,
  dispatch: PropTypes.func,
  helpCards: PropTypes.array,
  currentUser: PropTypes.object,
  propertyAttributes: PropTypes.object,
  marketingPartnerListing: PropTypes.object,
  onReloadDataTableMarketingPartnerListing: PropTypes.func,
};

PartnerOverviewPageTenantScreening.displayName = 'PartnerOverviewPageTenantScreening';

export default PartnerOverviewPageTenantScreening;
